import React from 'react';
import { Breadcrumb, Layout } from 'antd/lib';
import * as Icons from '@ant-design/icons';

import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';

import updateTipoExpedientePorId from '../../../graphql/mutations/contravenciones/updateTipoExpedientePorId.graphql';
import FormTipoExpediente from './FormTipoExpediente';
import getTipoExpedientePorId from '../../../graphql/querys/contravenciones/getTipoExpedientePorId.graphql';

const estiloContent = {
  marginTop: 16,
  border: '1px dashed #e9e9e9',
  borderRadius: 6,
  backgroundColor: '#fafafa',
  paddingTop: 20,
};

@compose(
  graphql(getTipoExpedientePorId, {
    name: 'getTipoExpedientePorId',
  }),
  graphql(updateTipoExpedientePorId, {
    name: 'updateTipoExpedientePorId',
  })
)
class VerTipoExpediente extends React.Component {
  state = {
    persona: {},
    step: 0,
    guardado: false,
    loading: false,
    tipoExpediente: {},
  };

  componentDidMount() {
    console.log('this.props');
    console.log(this.props);
    this.props.client
      .query({
        query: getTipoExpedientePorId,
        variables: {
          _id: this.props.match.params.id,
        },
      })
      .then(respuesta => {
        // console.log('La respuesta que recibo del get expediente por id es : ');
        // console.log(respuesta);

        this.setState({
          ...this.state,
          tipoExpediente: respuesta.data.getTipoExpedientePorId,
        });
      })
      .catch(err => {
        console.err('ERROR EN EL COMPONENT DID MOUNT');
        console.err(err);
      });
  }

  onSubmit = datos => {
    console.log('LLEGUE Y ENTRO: ', datos);

    let talonarios = [];

    _.each(datos.talonarios, par => {
      talonarios.push({
        idTalonario: par.talonario._id,
        idOrganismo: par.organismo._id,
      });
    });

    this.props
      .updateTipoExpedientePorId({
        variables: {
          _id: this.state.tipoExpediente._id,
          nuevoTipoExpediente: { ...datos, talonarios },
        },
      })
      .then(res => {
        // console.log('La respuesta que me llego fue...');
        // console.log(res);

        if (res.data.updateTipoExpedientePorId) {
          this.props.history.push(`/contravenciones/tipoExpedientes`);
        }
      })
      .catch(err => {
        console.log('ERROR A LA HORA DE CREAR UN TIPO DE EXPEDIENTE');
        console.log(err);
      });
  };

  onCancel = () => {
    this.props.history.goBack();
  };

  siguientePaso = () => {
    let paso = this.state.step;
    paso++;
    this.setState({
      ...this.state,
      step: paso,
    });
  };

  anteriorPaso = () => {
    let paso = this.state.step;
    if (paso > 0) {
      paso--;
      this.setState({
        ...this.state,
        step: paso,
      });
    }
  };

  render() {
    if (this.state.loading || !this.state.tipoExpediente) {
      return <Loading />;
    }
    return (
      <div>
        <Breadcrumb
          style={{
            margin: '12px 0',
          }}
        >
          <Breadcrumb.Item>Tipo Expediente</Breadcrumb.Item>
          <Breadcrumb.Item>Ver</Breadcrumb.Item>
        </Breadcrumb>
        <Layout
          style={{
            background: '#fff',
            padding: 24,
            minHeight: '80vh',
          }}
        >
          <h2 style={{ marginBottom: 10, textAlign: 'center' }}>
            <Icons.FileTextOutlined /> Ver Expediente
          </h2>
          <div style={estiloContent}>
            <FormTipoExpediente
              datos={this.state.tipoExpediente}
              onSubmit={this.onSubmit}
              onCancel={this.onCancel}
            />
          </div>
        </Layout>
      </div>
    );
  }
}

export default withApollo(VerTipoExpediente);
